import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="fade-in" style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="text-center" style={{ maxWidth: '500px', width: '100%', padding: '2rem' }}>
        {/* Decorative icon */}
        <div className="mb-4" style={{ fontSize: '6rem', color: 'var(--primary)', opacity: 0.8 }}>
          <i className="bi bi-compass"></i>
        </div>

        {/* 404 number */}
        <h1 style={{ 
          fontSize: '8rem', 
          fontWeight: 800,
          background: 'var(--primary-gradient)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          marginBottom: '1rem',
          lineHeight: 1
        }}>
          404
        </h1>

        {/* Title */}
        <h2 style={{ 
          fontSize: '1.75rem', 
          fontWeight: 700, 
          color: 'var(--text-primary)',
          marginBottom: '1rem'
        }}>
          Page Not Found
        </h2>

        {/* Description */}
        <p style={{ 
          fontSize: '0.95rem', 
          color: 'var(--text-secondary)',
          marginBottom: '2rem',
          lineHeight: 1.5
        }}>
          Sorry, the page you're looking for doesn't exist or has been moved.
          Please check the URL or return to the dashboard.
        </p>

        {/* Action button */}
        <button 
          onClick={() => navigate('/')}
          className="btn btn-primary"
          style={{ padding: '0.75rem 2rem', fontSize: '0.9rem' }}
        >
          <i className="bi bi-house-door me-2"></i>
          Back to Dashboard
        </button>

      </div>
    </div>
  );
};

export default NotFound;